import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, share } from 'rxjs';

import { IPvsShiftForemanInfo } from '../interfaces/pvs-shift.interface';

@Injectable({
  providedIn: 'root',
})
export class PvsShiftApiService {
  private readonly httpClient = inject(HttpClient);

  public getForemanList(): Observable<IPvsShiftForemanInfo[]> {
    return this.httpClient
      .get<
        IPvsShiftForemanInfo[]
      >(`${environment.API_URL}/dispatching/pvs/shift/foreman/list`)
      .pipe(share());
  }

  public start(id: number): Observable<unknown> {
    return this.httpClient
      .get(`${environment.API_URL}/dispatching/pvs/shift/${id}/start`)
      .pipe(share());
  }

  public finish(id: number): Observable<unknown> {
    return this.httpClient
      .get(`${environment.API_URL}/dispatching/pvs/shift/${id}/finish`)
      .pipe(share());
  }
}
